import React, { useEffect, useState } from "react";
import { Modal, Timeline, Typography } from "antd";
import {
    Box,
    Button,
    CircularProgress,
    IconButton,
    TextField,
    Typography as TypographyMUI
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { format, parseISO } from "date-fns";
import { addContactHistory, getAllContactHistory } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";

const { Text, Link } = Typography;

interface ContactHistoryProps {
  profileInfo: any;
  getWorkerInfo: any;
}

const ContactHistory: React.FC<ContactHistoryProps> = ({ profileInfo, getWorkerInfo }) => {
    const {state} = useAuth();
    const [open, setOpen] = useState(false);
    const [notes, setNotes] = useState("");
    const [loading, setLoading] = useState(false);
    const [contacts, setContacts] = useState([]);

    const handleSubmit = async () => {
        setLoading(true);
        const response = await addContactHistory(state.user?.token, {
            workerId: profileInfo?.id,
            callerUserId: state.user?.id,
            notes: notes
        });

        if(response?.status === 201) {
            setLoading(false);
            getWorkerInfo();
            setOpen(false);
        }
    };

    const getAllContacts = async () => {
        const response = await getAllContactHistory(state.user?.token, profileInfo?.id);
        if(response?.status === 200) {
            setContacts(response.data);
            getAllContacts()
        }
    };

    useEffect(() => {
        getAllContacts()
    }, [])

    return (
        <>
            <div>
                <TypographyMUI variant="body1" mt={1}>
                    <strong>Contact History</strong>
                    <IconButton
                        size="small"
                        sx={{ border: "none", marginBottom: 0.3 }}
                        aria-label="Add"
                        onClick={() => setOpen(true)}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </IconButton>
                </TypographyMUI>

                <Timeline
                    style={{ marginTop: 16 }}
                    items={contacts.map((item: any) => ({
                        dot: (
                            <div
                                style={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    backgroundColor: "#1976d2",
                                }}
                            />
                        ),
                        children: (
                            <div>
                                <Text type="secondary" style={{ color: '#333' }}>{format(parseISO(item?.callDate), 'dd MMM yyyy')}</Text>
                                <br />
                                <Link style={{ fontSize: 16, color: "#1976d2", fontWeight: 600 }}>{item?.callerUser}</Link>
                                <br />
                                <Text type="secondary"  style={{ color: '#656565ff' }}>{item?.notes}</Text>
                            </div>
                        ),
                    }))}
                />
            </div>
            <Modal
                title={`Add Contact History for ${profileInfo?.name} ${profileInfo?.surname}`}
                onCancel={() => setOpen(false)}
                open={open}
                footer={[
                    <div className="center-button-div">
                        <Button
                            disabled={loading}
                            variant="contained"
                            sx={{ boxShadow: 'none', mb: 2, width: 300 }}
                            onClick={handleSubmit}>
                            {loading? <CircularProgress size={20} style={{color: 'white'}} /> : 'Add Contact History'}
                        </Button>
                    </div>
                ]}>
                    <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr" }} gap={4} mt={4}>
                        <TypographyMUI variant="body1">
                            <strong>Date:</strong> {format(new Date(), "dd/MM/yyyy")}
                        </TypographyMUI>
                        <TextField
                            label="Notes"
                            placeholder="Write notes here..."
                            multiline
                            rows={4}
                            size="small"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </Box>
            </Modal>
        </>
    );
};

export default ContactHistory;
